export default __webpack_public_path__ + "static/media/contacts-phone.ed26db80.svg";